export function waitForTimeout(timeout) {
  return new Promise((resolve) => {
    const timeoutId = setTimeout(() => {
      resolve(timeoutId);
    }, timeout);
  });
}
